import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styles from './style.module.css';
import { Box, Grid, LinearProgress } from '@mui/material';
import { ROUTES } from '../../../const';
import { PaymentHelper } from '../../../helpers/PaymentHelper';

function PaymentCallback() {
  const history = useHistory();
  const { shopId } = useParams();

  useEffect(() => {
    const orderDetails = PaymentHelper.getLastPaymentFromLocalStorage(shopId);

    if (!orderDetails) {
      history.push('/');
      return;
    }

    if (orderDetails?.payment_id && orderDetails?.payment_secret) {
      const url = ROUTES.PAYMENT_STATUS.replace(':shopId', orderDetails.shop_id);
      const query = `?message=Ok&payment_id=${orderDetails?.payment_id}&secret=${orderDetails?.payment_secret}`;
      history.push(url + query);
      return;
    }
    history.push(ROUTES.SHOP_HOME.replace(':shopId', orderDetails.shop_id));
  }, [history, shopId]);

  return (
    <div className={styles.container}>
      <Grid className={styles.loderContaner} flexDirection="column">
        <p style={{ paddingBottom: 20 }}>Payment Processing.....</p>
        <Box sx={{ width: '40%' }}>
          <LinearProgress />
        </Box>
      </Grid>
    </div>
  );
}

export default PaymentCallback;
